<dx-data-grid
  *ngIf="vehicleService"
  height="100%"
  width="auto"
  [dataSource]="vehicleService.serviceStates"
  [remoteOperations]="false"
  (onRowInserting)="onServiceStateInserting($event)"
  (onRowUpdating)="onServiceStateUpdating($event)"
  (onRowRemoving)="onServiceStateRemoving($event)">
  <!-- Settings -->
  <dxo-editing mode="row" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"></dxo-editing>
  <dxo-export [enabled]="true" fileName="service-states-export"></dxo-export>

  <!-- Columns -->
  <dxi-column caption="State" dataField="state" dataType="string" [allowEditing]="true">
    <dxo-lookup [dataSource]="helperService.serviceStates" displayExpr="name" valueExpr="id"></dxo-lookup>
  </dxi-column>
  <dxi-column caption="Comment" dataField="comment" dataType="string" [allowEditing]="true">
    <dxi-validation-rule type="required" message="Comment is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    caption="Created At"
    dataField="createdAt"
    dataType="date"
    format="shortDateShortTime"
    [allowEditing]="false"></dxi-column>
  <dxi-column caption="Created By" dataField="createdBy.username" [allowEditing]="false"></dxi-column>
</dx-data-grid>
